import api from "@/services/api";

export const getIncome = data => {
  return api("post", "metrics/income", data).then(response => {
    return response;
  });
};

export const getPatients = data => {
  return api("post", "metrics/patient", data).then(response => {
    return response;
  });
};

export const getAppointments = data => {
  return api("post", "metrics/appointment", data).then(response => {
    return response;
  });
};

export const getReviews = data => {
  return api("post", "metrics/review", data).then(response => {
    return response;
  });
};

export const getQueryPerPatient = data => {
  return api("post", "metrics/query_per_patient", data).then(response => {
    return response;
  });
};

export const getSurveyDetail = (data, allData = false) => {
  return api("post", "metrics/review_detail", data, allData).then(response => {
    return response;
  });
};
